import React, { useState, useEffect } from 'react'
import { Outlet, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Header from "../components/Header";
import Newsflash from "../components/Newsflash";
import Footer from "../components/Footer";
import TopNavigation from "../components/TopNavigation";
import { LeftNavigation } from '../components/VerticaltNavigation';
import { TrackHeight } from '../components/TrackSize';
import BarNav from '../components/BarNav';

const MainArea = styled.div`
    background: ${({content}) => content.mainBgColor};
    min-height: ${({content}) => content};
`;

const LeftNav = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
`;

const TopNav = styled.div`
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
`;

const Border = styled.div`
    display: flex;
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
`;


export default function Root({content, smallWindow, windowSize, setTopNavWidth, setTopNavHeight}) {
  const [loadToRootDone, setLoadToRootDone] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [navHeight, setNavHeight] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loadToRootDone) {
      setLoadToRootDone(true);  
      return navigate("/");
    }
  }, [loadToRootDone, navigate]);

  const borderWidth = !content.styles.verticleBorders ? '0px' : smallWindow ? '5px' : '20px';
  const minHeight = Math.max(windowSize.height - headerHeight - footerHeight, navHeight);
  const minHeightPx = minHeight.toString() + 'px';

  if (content.menuPosition === 'Top' || smallWindow) {
    return (
      <div style={{minWidth: '320px'}}>
        <TrackHeight setSize={setHeaderHeight} windowSize={windowSize}>
            <Header content={content} smallWindow={smallWindow} windowSize={windowSize}/>
            <TopNav content={content.styles}>
              {(smallWindow) ?  <BarNav content={content}/> 
              : <TrackHeight setSize={setTopNavHeight} windowSize={windowSize}>
                  <TopNavigation content={content} setTopNavWidth={setTopNavWidth} windowSize={windowSize}/>
                </TrackHeight>
              }
            </TopNav>
        </TrackHeight>
  
        <Border content={content.styles}>
          <div><p style={{width: borderWidth}}></p></div>
          <div style={{flexGrow: 1}}>
          <MainArea content={{...content.styles, minHeight: minHeightPx}}>
            <Newsflash content={content}/>
            <Outlet/>
          </MainArea>
          </div>
          <div><p style={{width: borderWidth}}></p></div>
        </Border>
  
        <TrackHeight setSize={setFooterHeight} windowSize={windowSize}>
          <Footer content={content} />
        </TrackHeight>
      </div>
    );
} else {
  // menuPosition == left
  return (
    <>
      <TrackHeight setSize={setHeaderHeight} windowSize={windowSize}>
        <Header content={content} smallWindow={smallWindow}/>
        <div><p style={{height:'20px', background: content.styles.titleBgColor}}></p></div>
      </TrackHeight>
      
      <LeftNav content={content.styles}>
        <div>
          <LeftNavigation content={content} setNavHeight={setNavHeight} windowSize={windowSize}/>
        </div>
        <div style={{flexGrow: 1}}>

          <MainArea content={{...content.styles, minHeight: minHeightPx}}>
            {(content.newsflash.enabled) ? <Newsflash content={content}/> : null}
            <Outlet/>
          </MainArea>
        </div>
        <div><p style={{width: borderWidth}}></p></div>
      </LeftNav>

      <TrackHeight setSize={setFooterHeight} windowSize={windowSize}>
        <Footer content={content} />
      </TrackHeight>
    </>
  );

}


}
